import PropTypes from 'prop-types';
import { useEffect, useRef } from '@web-stories-wp/react';
import { ColorSwatch } from './textEffectStyles';

export default function EffectColorInput({
  onPreviewChange,
  onChange,
  onBlur,
  ...props
}) {
  const input = useRef(null);
  const commit = useRef(onChange);
  commit.current = onChange;
  useEffect(() => {
    const node = input.current;
    const finish = (event) => commit.current(event.target.value);
    // React may suppress change after input reported the same color. Listen to
    // the native picker completion so its final value flushes before dismissal.
    node.addEventListener('change', finish);
    return () => node.removeEventListener('change', finish);
  }, []);
  return (
    <ColorSwatch
      {...props}
      ref={input}
      type="color"
      onInput={(event) => onPreviewChange(event.target.value)}
      onChange={() => {}}
      onBlur={onBlur}
    />
  );
}
EffectColorInput.propTypes = {
  onPreviewChange: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};
